module.exports = __webpack_public_path__ + "img/10894_S.13771355.png";